import Vue from "vue";
import Vuex from "vuex";
import {
  getUserData,
  getAccessData,
  userLogin,
  userLogOut,
  getFeedbackFormfromUuid,
  getProfilePic,
  getProjectUsers,
  getAllThirdParties,
} from "../../utils/apiFunctions.js";
import { resetRouter } from "../../router";
import {
  setToken,
  getToken,
  getRefreshToken,
  clearCookies,
} from "../../utils/tokenCheck";
// import store from "../index.js";
import store from "../index.js";
const qs = require("qs");
Vue.use(Vuex);

// State
const state = () => ({
  showMenu: false,
  licenseKey: "",
  token: "",
  refreshToken: "",
  currentComponent: "",
  loggedin: true,
  user: {
    userID: "",
    email: "",
    profileImage: "",
  },
  googleCredentials: {},
  roleValues: {},
  showpref: false,
  panelID: null,
  // role: {},
  projectUsers: {},
  email: "",
  roles: [],
  thirdPartyData: [],
  rmConfig: null,
  vendorData: null,
  vendorID: null,
});

// getters
const getters = {
  getPanelID: (state) => state.panelID,
  getShowPref: (state) => state.showpref,
  // checkLoginStatus: (state) => state.loggedin,
  getlicenseKey: (state) => state.licenseKey,
  getCredentials: (state) => state.googleCredentials,
  getUserDetail: (state) => state.user,
  getRoleValues: (state) => state.roleValues,
  getUserToken: (state) => state.token,
  getUserRefreshToken: (state) => state.refreshToken,
  getMenuStatus: (state) => state.showMenu,
  getLoggedInUserEmail: (state) => state.email,
  getProjectUsers: (state) => state.projectUsers,
  getThirdPartyData: (state) => state.thirdPartyData,
  getCurrentComponent: (state) => state.currentComponent,
  getRMConfig: (state) => state.rmConfig,
  getVendorData: (state) => state.vendorData,
  getVendorID: (state) => state.vendorID,
};

// actions
const actions = {
  setCredentials({ commit }, googleCredentials) {
    commit("setCredentials", googleCredentials);
  },
  setLoggedInUserEmail({ commit }, email) {
    commit("saveUserEmail", email);
  },
  async getUserData({ commit }, setRoleValue) {
    try {
      const response = await getUserData();
      let data = await response.data.data.LicenseKey;
      // return response
      commit("saveLicenseKey", data);
      let payload = {
        user: "USER",
        licensekey: data,
        searchQuery: "",
      };
      if (response.status == 200) {
        const res = await getAccessData(payload);
        let userDetails = await res.data.data.Data[0];
        const { permissions } = userDetails;
        if (userDetails.subAdmin) {
          permissions.push("SUB_ADMIN");
        }
        if (setRoleValue == "setRole") {
          commit("SET_ROLES", permissions);
        }
        commit("getRoleValue", userDetails);

        // -------- To get profile Image ----------
        let generatedName = "Guest";
        if (userDetails.username) {
          generatedName = userDetails.username.split(" ");
          if (generatedName.length > 1) {
            generatedName = generatedName[0][0] + generatedName[1][0];
          } else {
            generatedName = generatedName[0][0];
          }
        } else {
          generatedName = store.state.email;
        }
        const userImage = await getProfilePic(generatedName);
        if (userImage.status == 200) {
          commit("saveUserData", {
            jwttoken: res.data.data.Data[0].userID,
            email: "",
            profileImage: userImage.data.data.link,
          });
        }

        const userData = await getProjectUsers();
        if (userData.status == 200) {
          commit("setProjectUsers", userData.data.data);
        }
        let payloadnew = {
          sortBy: "name",
          order: false,
        };
        const thirdPartyData = await getAllThirdParties(payloadnew);
        if (thirdPartyData.status == 200) {
          commit("setThirdPartyData", thirdPartyData.data.data);
          commit("setRMConfig", thirdPartyData.data.data.rmConfig);
        }
        // -------- To get profile Image ----------
        return userDetails;
      } else {
        let userDetails = {};
        commit("getRoleValue", userDetails);
        throw new Error(`Failed! Value Not Stored`);
      }
    } catch (error) {
      throw new Error(`Getting Licencse Failed! status: ${error.status}`);
    }
  },
  async checkPanelLogin(state) {
    console.log(state.getters.getPanelID);
    try {
      let data = {
        uuid: state.getters.getPanelID,
      };
      const res = await getFeedbackFormfromUuid(data);
      return res.status;
    } catch (error) {
      console.log(error);
      return null;
    }
  },

  // GetInfo(state) {
  //   return new Promise((resolve, reject) => {
  //     getUserAndRolesData(state.licenseKey)
  //       .then((response) => {
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },
  // http://sso.simplifycv.com/
  // https://auth.simplifymycareer.com/
  // Login Api
  Login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo.keycloak, {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      })
        .then((response) => {
          const data = response.data;
          if (data.access_token) {
            setToken(data.access_token);
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            resolve(response);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // LogOut Api
  LogOut(state) {
    resetRouter();
    userLogOut(
      qs.stringify({
        client_id: "vue-test-app",
        refresh_token: getRefreshToken(),
      }),
      {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        Authorization: `Bearer ${getToken()}`,
      }
    )
      .then((response) => {
        clearCookies();
        state.commit("SET_ROLES", []);
        state.commit("SET_TOKEN", "");
        state.commit("SET_REFRESH_TOKEN", "");
        state.commit("saveLicenseKey", "");
        state.commit("setShowPref", false);
        state.commit("getRoleValue", {});
        state.commit("setVendorData", null);
        state.commit("setVendorID", null);
        if (store.getters["userVUEX/getPanelID"]) {
          location.replace(
            `https://app.hire3x.com/login?from=recruitment&uuid=${store.getters["userVUEX/getPanelID"]}&panel=true`
            // `http://localhost:8080/login?from=recruitment&uuid=${store.getters['userVUEX/getPanelID']}&panel=true`
          );
        } else {
          // location.replace("http://localhost:8080/login?from=recruitment");
          // location.replace(
          //   "https://simplifymycareer.com/login?from=recruitment"
          // );
          location.replace("https://app.hire3x.com/login?from=recruitment");
        }
        return response;
      })
      .catch((error) => {
        clearCookies();
        state.commit("SET_ROLES", []);
        state.commit("SET_TOKEN", "");
        state.commit("SET_REFRESH_TOKEN", "");
        state.commit("saveLicenseKey", "");
        state.commit("setShowPref", false);
        state.commit("getRoleValue", {});
        state.commit("setVendorData", null);
        state.commit("setVendorID", null);
        if (store.getters["userVUEX/getPanelID"]) {
          location.replace(
            `https://app.hire3x.com/login?from=recruitment&uuid=${store.getters["userVUEX/getPanelID"]}&panel=true`
            // `http://localhost:8080/login?from=recruitment&uuid=${store.getters['userVUEX/getPanelID']}&panel=true`
          );
        } else {
          // location.replace("http://localhost:8080/login?from=recruitment");
          // location.replace(
          //   "https://simplifymycareer.com/login?from=recruitment"
          // );
          location.replace("https://app.hire3x.com/login?from=recruitment");
        }
        throw error;
      });
  },
};

// mutations
const mutations = {
  setRMConfig(state, payload) {
    state.rmConfig = payload;
  },
  setVendorData(state, payload) {
    state.vendorData = payload;
  },
  setCurrentComponent(state, payload) {
    state.currentComponent = payload;
  },
  setCredentials(state, googleCredentials) {
    state.googleCredentials = googleCredentials;
  },
  setThirdPartyData(state, payload) {
    state.thirdPartyData = payload;
  },
  setProjectUsers(state, payload) {
    state.projectUsers = payload;
  },
  setPanelID(state, payload) {
    state.panelID = payload;
  },
  setShowPref(state, payload) {
    state.showpref = payload;
  },

  saveUserEmail(state, email) {
    state.email = email;
  },
  // TOGGLE MENU SIDE BAR
  setMenuStatus(state, payload) {
    state.showMenu = payload;
  },

  // Storing Roles Value
  SET_ROLES(state, roles) {
    state.roles = roles;
  },
  // Storing LicenseKey
  saveLicenseKey(state, payload) {
    state.licenseKey = payload;
  },
  // ------- User Data --------- whether the user is loggedIn or not
  checkLoginStatus(state, payload) {
    state.loggedin = payload;
  },

  saveUserData(state, payload) {
    state.user.userID = payload.jwttoken;
    state.user.email = payload.email;
    state.user.profileImage = payload.profileImage;
  },
  // Storing User Role & Access Values
  getRoleValue(state, payload) {
    state.roleValues = payload;
  },
  // Storing Token
  SET_TOKEN(state, token) {
    state.token = token;
  },
  // Storing Refresh Token
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  setVendorID(state, payload) {
    state.vendorID = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
